import React from "react";
import { Routes, Route } from "react-router-dom";
import SubPage from "components/pages/role/sub-pages";
import type { TRole } from "components/role/helpers/role-types-helper";
import { PermissionGuard } from 'components/permissions';
import Roles from 'components/role';
import { Pages } from 'components/pages';

interface IRoleRouteProps
{
  role: TRole | undefined;
}

const RoleRoute: React.FC<IRoleRouteProps> = ({ role }) =>
{
  return (
    <PermissionGuard
      permission={Roles.Const.permissions.VIEW}
      fallback={<Pages.Page403 />}
    >
      <Routes>
        <Route path="/" element={<SubPage.OverView role={role} />} />
        <Route path="/users/page/:pageNum" element={<SubPage.Users role={role} />} />
        <Route path="/users/page" element={<SubPage.Users role={role} />} />
        <Route path="/users" element={<SubPage.Users role={role} />} />
      </Routes>
    </PermissionGuard>
  );
};

export default RoleRoute;